import { render, staticRenderFns } from "./IcraEmri55Taslak.vue?vue&type=template&id=4cc87315"
import script from "./IcraEmri55Taslak.vue?vue&type=script&lang=ts"
export * from "./IcraEmri55Taslak.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports